'use strict';

module.exports = footnote;

function footnote(node) {
  return '[^' + this.all(node).join('') + ']';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/footnote.js
// module id = 967
// module chunks = 95715928098905 168707334958949